<template lang="html">
  <div class="">
    <p v-if="label != ''" class="pt-0 mb-0 small">
      {{ label }}
    </p>
    <vue-slider
      v-model="_value"
      :min="min"
      :max="max"
      :interval="interval"
      :lazy="false"
      :adsorb="true"
      :tooltip-formatter="tooltip_formatter"
      class="slider mb-3"
    />
  </div>
</template>

<script>
export default {
  name: "Slider",
  props: {
    value: {
      type: Number,
      default: () => 10
    },
    min: {
      type: Number,
      default: () => 0
    },
    max: {
      type: Number,
      default: () => 100
    },
    interval: {
      type: Number,
      default: () => 1
    },
    label: {
      type: String,
      default: () => ""
    },
    tooltip_formatter: {
      type: Function,
      default: v => v
    }
  },
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("changed", value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.slider {
  margin-left: 6px;
  margin-right: 6px;
}
//.slider .vue-slider-mark-step {
//  background: #cfcfcf !important;
//}
//.slider .vue-slider-mark-label-active {
//  color: black !important;
//}
</style>
